import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { BasicTooltip, LoaderButton, Icon, SimpleModal } from '@livable/saas-react-components';
import { Button } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import OccupancyTabContent from 'src/components/unit/OccupancyTabContent';
import { useStore } from 'src/stores';
import useStyles from './styles';
export default function OccupancyUpdateModal(_ref) {
  var _unitData$;
  let trigger = _ref.trigger,
    buildingId = _ref.buildingId,
    currentOccupancy = _ref.currentOccupancy,
    unitData = _ref.unitData,
    parentToggleRefreshCallback = _ref.parentToggleRefreshCallback;
  const classes = useStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(currentOccupancy),
    _useState2 = _slicedToArray(_useState, 2),
    initOccupancy = _useState2[0],
    setInitOccupancy = _useState2[1];
  const _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    isDisabled = _useState4[0],
    setIsDisabled = _useState4[1];
  const _useState5 = useState(currentOccupancy),
    _useState6 = _slicedToArray(_useState5, 2),
    occupancy = _useState6[0],
    setOccupancy = _useState6[1];
  const _useState7 = useState('initial'),
    _useState8 = _slicedToArray(_useState7, 2),
    status = _useState8[0],
    setStatus = _useState8[1];
  const _useState9 = useState([]),
    _useState0 = _slicedToArray(_useState9, 2),
    unitUtilitiesFromApi = _useState0[0],
    setUnitUtilitiesFromApi = _useState0[1];
  const _useState1 = useState([]),
    _useState10 = _slicedToArray(_useState1, 2),
    inUnitAmenitiesFromApi = _useState10[0],
    setInUnitAmenitiesFromApi = _useState10[1];
  const _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    utilityIdsFromApi = _useState12[0],
    setUtilityIdsFromApi = _useState12[1];
  useEffect(() => {
    const fetchUnits = async () => {
      var _store$homeDashboardS, _resp$response, _currentUnit$unitUtil, _currentUnit$inUnitAm, _currentUnit$utilityI;
      const resp = await store.units.getUnitsAsync.run({
        applyToHomeDashboard: true,
        buildingId: (_store$homeDashboardS = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS === void 0 || (_store$homeDashboardS = _store$homeDashboardS.buildingInformation) === null || _store$homeDashboardS === void 0 ? void 0 : _store$homeDashboardS.id
      });
      const units = (_resp$response = resp === null || resp === void 0 ? void 0 : resp.response) !== null && _resp$response !== void 0 ? _resp$response : [];
      const currentUnit = units.find(u => u.id === unitData[0].id);
      setUnitUtilitiesFromApi((_currentUnit$unitUtil = currentUnit === null || currentUnit === void 0 ? void 0 : currentUnit.unitUtilities) !== null && _currentUnit$unitUtil !== void 0 ? _currentUnit$unitUtil : []);
      setInUnitAmenitiesFromApi((_currentUnit$inUnitAm = currentUnit === null || currentUnit === void 0 ? void 0 : currentUnit.inUnitAmenities) !== null && _currentUnit$inUnitAm !== void 0 ? _currentUnit$inUnitAm : []);
      setUtilityIdsFromApi((_currentUnit$utilityI = currentUnit === null || currentUnit === void 0 ? void 0 : currentUnit.utilityIds) !== null && _currentUnit$utilityI !== void 0 ? _currentUnit$utilityI : []);
    };
    fetchUnits();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- run once when modal opens and unitData is available
  }, [unitData === null || unitData === void 0 || (_unitData$ = unitData[0]) === null || _unitData$ === void 0 ? void 0 : _unitData$.id]);
  useEffect(() => {
    const updatedData = _objectSpread(_objectSpread({}, unitData[0]), {}, {
      occupancy,
      inUnitAmenities: inUnitAmenitiesFromApi,
      optOutUtilityIds: [...utilityIdsFromApi],
      unitId: unitData[0].id,
      unitUtilities: unitUtilitiesFromApi,
      utilityIds: utilityIdsFromApi
    });
    const data = {
      buildingId,
      units: {
        toCreate: [],
        toUpdate: [_objectSpread({}, updatedData)],
        toDelete: []
      }
    };
    const updateUnits = async () => {
      const resp = await store.units.updateUnitsAsync.run(data);
      return resp;
    };
    if (status === 'loader') {
      updateUnits().then(resp => {
        if (resp && resp.isSuccessful) {
          // eslint-disable-next-line @typescript-eslint/no-unused-expressions
          parentToggleRefreshCallback && parentToggleRefreshCallback();
          setInitOccupancy(occupancy);
        } else {
          setStatus('error');
        }
      }).finally(() => {
        setStatus('success');
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status, unitUtilitiesFromApi, inUnitAmenitiesFromApi, utilityIdsFromApi]);
  const handleOccupancyChange = value => {
    if (status === 'initial') {
      setIsDisabled(initOccupancy === value);
    } else {
      if (initOccupancy === value) {
        setStatus('success');
      } else {
        setStatus('saveAnother');
      }
      setIsDisabled(false);
    }
    setOccupancy(value);
  };
  const handleClick = () => {
    if (initOccupancy === occupancy) return;
    setIsDisabled(false);
    setStatus('loader');
  };
  const defaultTrigger = /*#__PURE__*/React.createElement(BasicTooltip, {
    title: t('residencies_page.change_occupancy'),
    placement: "top",
    hideOnMobile: true
  }, /*#__PURE__*/React.createElement(Button, {
    className: "".concat(classes.lightTrigger, " ").concat(classes.occupancyTrigger),
    size: "small",
    variant: "actionIcon",
    'custom-attribute': '479-occupancy-update-modal'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "group"
  })));
  return /*#__PURE__*/React.createElement(SimpleModal, {
    handleClose: () => {
      store.residencies.toggleRefreshFlag(true);
      store.residencies.resetDataGrid();
    },
    trigger: trigger || defaultTrigger,
    title: t('residencies_page.update_occupancy'),
    rightButton: /*#__PURE__*/React.createElement(LoaderButton, {
      buttonText: "Save changes",
      disabled: isDisabled,
      errorText: "Saving failed",
      handleClick: () => handleClick(),
      loadingText: "Saving...",
      status: status,
      successText: "Saved successfully",
      'custom-attribute': '480-occupancy-update-modal'
    })
  }, /*#__PURE__*/React.createElement(OccupancyTabContent, {
    handleOccupancyChange: handleOccupancyChange,
    occupancy: occupancy
  }));
}